import React, { useState } from 'react';

import { Box, Icon, IconButton, Tooltip } from '@chakra-ui/react';
import { FiCheck, FiCopy } from 'react-icons/fi';

/** A fenced code block with a copy button. */
export const DocumentationCodeBlock = ({
  code,
  maxH,
}: {
  code: string;
  /** Caps the height for long output, e.g. API responses. */
  maxH?: string;
}) => {
  const [copied, setCopied] = useState(false);
  const copy = () =>
    navigator.clipboard?.writeText(code).then(() => {
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2000);
    });
  return (
    <Box
      position="relative"
      mb={5}
      bg="gray.50"
      border="1px solid"
      borderColor="gray.200"
      borderRadius="md"
    >
      <Tooltip label={copied ? 'Copied' : 'Copy'} placement="top" hasArrow>
        <IconButton
          aria-label={copied ? 'Copied' : 'Copy code'}
          icon={<Icon as={copied ? FiCheck : FiCopy} />}
          size="sm"
          variant="ghost"
          color={copied ? 'green.500' : 'gray.500'}
          position="absolute"
          top={1.5}
          right={1.5}
          onClick={copy}
        />
      </Tooltip>
      <Box
        as="pre"
        m={0}
        py={3}
        pl={4}
        pr={12}
        overflowX="auto"
        overflowY={maxH ? 'auto' : undefined}
        maxH={maxH}
        fontFamily="mono"
        fontSize="14px"
        lineHeight={1.6}
        color="gray.800"
        whiteSpace="pre"
      >
        <code>{code}</code>
      </Box>
    </Box>
  );
};
